module.exports = __webpack_public_path__ + "static/img/program_10.32fcea8.jpg";


//////////////////
// WEBPACK FOOTER
// ./src/assets/img/recruit/2025/top/company/program_10.jpg
// module id = kNvp
// module chunks = 0